import React from 'react';
import classnames from 'classnames';
import s from './CentralColumn.scss';
const CentralColumn = ({ className , children , supportSidebar  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], supportSidebar && s['sidebar'], className)
    }, children);
};
CentralColumn.displayName = 'CentralColumn';
export default CentralColumn;
